module.exports = __webpack_public_path__ + "static/media/Summer.b2af43f3.jpg";